import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';

import Table from '../commons/Table';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

import Edit from './Edit';
import moment from 'moment';

const store = Stores.load('rodada', 'numero');

class Rodada extends React.Component {
  componentWillMount() {
    UIStore.init(i_.t('rodada.title'), store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      i_.t('dialogs.remove-message', { count }),
      i_.t('dialogs.remove-title', { entity: 'rodada' })
    ).then(b => {
      if (b) {
        store.delete().then(() => store.query());
      }
    });
  };

  render() {
    return (
      <div>
        <Table
          columns={[
            { label: i_.t('rodada.pesquisa'), field: 'pesquisa.nome' },
            { label: i_.t('rodada.numero'), field: 'numero' },
            {
              label: i_.t('rodada.inicio'),
              field: 'inicio',
              func: d => moment(d).format('DD/MM/YYYY'),
            },
            {
              label: i_.t('rodada.fim'),
              field: 'fim',
              func: d => moment(d).format('DD/MM/YYYY'),
            },
          ]}
          store={store}
          data={store.list}
          selected={store.selected}
          onAdd={() =>
            store.new({
              pesquisa: '',
              numero: '',
              amostra: 0,
              inicio: moment().format('YYYY-MM-DD'),
              fim: moment().format('YYYY-MM-DD'),
            })
          }
          onEdit={() => store.open()}
          onDelete={() => this.handleDelete()}
        />
        <Edit />
      </div>
    );
  }
}

export default observer(Rodada);



// WEBPACK FOOTER //
// ./src/components/rodada/index.js